<template>
    <div class="doctors-box app">
        <swiperBanner :bannerList='bannerList'></swiperBanner>
        <div class="main-content">
            <div class="tab-box clearfix hand-shape">
               <div class="tab" :class="{active:status==index}"  @click="getSwitchList(index)" v-for="(tab,index) in switchTab" :key="index">{{tab.name}}<span class="tab-line bg-blue"></span></div>
            </div>
            <div class="main-ui clearfix">
                <div class="main-li fl hand-shape" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.doctor_id)">
                    <div class="img-out tc color-blank">
                        <div class="avatar">
                            <img :src="item.img" :alt="item.name" class="img-responsive">
                        </div>
                        <div class="name fwb fs18 color-blank txt_limit">{{item.name}}</div>
                        <div class="job-title fs14 color-blank txt_limit">{{item.position}}</div>
                        <div class="depart color-gray color-gray txt_limit">{{item.department}}</div>
                    </div>
                    <div class="doctor-box">
                        <img src="../../assets/images/dash-line.png" alt="">
                        <div class="detail txt_limit2">{{item.description}}</div>
                    </div>
                </div>
            </div>
            <el-col  :span="24" class="toolbar">
                <el-pagination
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="alltotal">
                </el-pagination>
                <nav-top></nav-top>
            </el-col>
        </div>
    </div>
</template>

<script>
import swiperBanner from '@/components/swiperBanner'
import navTop from '@/components/top'
import seoArgs from '../../utils/setSeoArgs';

export default {
    props: {

    },
    data() {
        return {
            page: 1,//重新获取的当前的页码
            alltotal:10,//总的数据
            pageSize:9,//每一条的页数是10
            bannerList:[],
            switchTab: [
				{ name: '医生集团委员',id:1},
				{ name: '医生集团成员',id:2}	
            ], 
            dataList:[],
            status: this.$route.params.categoryId || 0
        };
    },
    created() {
        const doctorSeoInfo = this.$cookies.get(this.api.cachePrex+'DoctorGroup') || {};
        doctorSeoInfo.name = '医生集团';
        seoArgs.setSeoArgs(doctorSeoInfo);

        this.getBanner();
        this.getList();
    },
    methods: {
        getBanner(){
            this.$axios.post(this.api.index.banners,{item:'DoctorGroup'},res =>{
                this.bannerList=res.data;
                if(this.bannerList.length==0){
                    this.bannerList=[{img: "../../static/banner.png"}];
                }
            },err =>{
                this.bannerList=[];
            });
        },
        getSwitchList(index){
            this.status=index;
            this.getList();
        },
        getList() {
            this.$axios.post(this.api.doctorGroup.list,{
                class:this.switchTab[this.status].id,
                page:this.page,
                page_size:this.pageSize
            },res =>{
                this.dataList=res.data;
                this.alltotal=Number(res.pageInfo.totalCount);
            },err =>{
                this.dataList=[];
            });
        },
        goDetail:function(id){
            this.$router.push('/doctorGroupDetail/'+ this.status +'/'+id+'/'+this.switchTab[this.status].name+'.html');
        },
        //页面改变
        handleCurrentChange(val) {
            this.page=val;
            this.getList();
        },
        //每页的页数改变
        handleSizeChange(val) {
            this.pageSize=val;
            this.getList();
        },
    },
    components: {
        swiperBanner,
        navTop
    },
};
</script>

<style scoped>
    .main-ui{padding:40px 0;}
    .main-li{margin-bottom:20px;padding:20px;width:380px;height:406px;background:rgba(255,255,255,1);box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);border-radius:5px;margin-right:30px;}
    .main-li:hover{box-shadow:0px 0px 10px 0px rgba(0,0,0,0.4);}
    .main-li:nth-child(3n){margin-right:0;}
    .main-li .avatar{width:120px;height:120px;border-radius:50%;overflow: hidden;margin:10px auto 30px;}
    .main-li .img-out .name{line-height:25px;height:25px;}
    .main-li .img-out .job-title{margin:10px;line-height:20px;height:20px;}
    .main-li .img-out .depart{line-height:20px;height:20px;}
</style>



// WEBPACK FOOTER //
// src/view/doctors/index.vue